<template>
  <v-tooltip :disabled="disableTooltip || $vuetify.display.xs">
    <template #activator="{ props: tooltipProps }">
      <v-avatar
        v-bind="{ ...tooltipProps, ...$attrs }"
        class="elevation-1 font-weight-medium text-body-medium border border-opacity-75"
        rounded
        theme="dark"
        size="small"
        :color="category.marker.color"
      >
        {{ category.marker.description }}
      </v-avatar>
    </template>

    <template #default>
      <div>{{ $t("assets.field.category") }}: {{ category.description }}</div>
    </template>
  </v-tooltip>
</template>

<script setup lang="ts">
const props = defineProps<{ category: Pick<AssetCategory, "marker" | "description">; disableTooltip?: boolean }>()
const { category, disableTooltip } = toRefs(props)
</script>
